/// <reference path="../Tag.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class FileInput extends Tag {

        public triggerClick() {
            const element: HTMLElement =  this.get("input").getElement() as HTMLElement;
            element.click();
        }

        public getFiles(): File[] {
            return this.get("files");
        }

        public clear(): this {
            this.getFilenameDiv().setText("selectionnez un fichier...");
            return this;
        }

        public inputHasChanged(event: Event | any) {
            const files: File[] = event.target.files;
            const filename = (files.length > 1) ? files[0].name + " " + (files.length) + " fichiers" : files[0].name ;

            this.getFilenameDiv().setText(filename);
            this.addToData("files", files);
        }

        public getText(): string {
            return this.getElement().value;
        }

        public setText(value: any): string {
            return this.getElement().value = value;
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            if (data === undefined) {
                data = toMap({});
            }
            data.set("element", Tag.createElement("div"));
            super.initialize(data);

            const me = this;
            const input = new Input(toMap({
                    onChange: (event: any) => {
                        me.inputHasChanged(event);
                        if(data.has("oc")) {
                            data.get("oc")();
                        }
                    },
                }));

            if (this.hasNot("max") || this.get("max") > 1) {
                input.setAttribute("multiple", 1);
            }

            const filename = new Div("selectionnez un fichier...");
            this.addToData("input", input);
            this.addToData("filename", filename);

            input.setAttribute("type", "file");
            if (data.get("accept")) {
                input.setAttribute("accept", data.get("accept"));
            }

            input.invisible();
            this.appendChild(filename);
            this.appendChild(input);

            filename.addClass("fname");

        }

        /**
         * @return {Div}
         */
        protected getFilenameDiv() {
            return this.get("filename");
        }
    }
}
